import InfoSpot from "./InfoSpot";

export default class Room {
    constructor(props) {
        /**
         * WordPress post id
         */
        this.id = props?.id ?? 0;

        /**
         * Room Title
         */
        this.title = props?.title ?? '';

        /**
         * List of info spots in this room
         * @type InfoSpot[]
         */
        this.spots = props?.spots?.map((spot, i) => new InfoSpot({
            spot: spot.info_spot,
            x: spot.position_x,
            y: spot.position_y,
            index: i + 1,
        })) ?? [];

        /**
         * Room excerpt
         */
        this.excerpt = props?.excerpt ?? '';

        /**
         * Full room page content in HTML
         */
        this.content = props?.content ?? '';

        /**
         * Room Thumbnail Sizes
         */
        this.post_thumbnail = props?.thumbnail ?? [];

        this.tutorial_fields = props?.tutorial_fields ?? false;
        this.museum_fields = props?.museum_fields ?? false;
    }

    get thumbnailUrl() {
        return this?.post_thumbnail?.sizes?.original?.url ?? '';
    }

    get isTutorialRoom() {
        return (typeof this.tutorial_fields !== 'undefined' && this.tutorial_fields !== false);
    }

    get isMuseumRoom() {
        return (typeof this.museum_fields !== 'undefined' && this.museum_fields !== false);
    }

    static fromJson(json) {
        let data = JSON.parse(json);
        return Room.fromObj(data);
    }

    static fromObj(obj) {
        return new Room(
            {
                id: obj.ID,
                title: obj.post_title,
                spots: obj.info_spots ?? [],
                excerpt: obj.post_excerpt,
                content: obj.post_content,
                thumbnail: obj.post_thumbnail,
                tutorial_fields: obj.tutorial_fields,
                museum_fields: obj.museum_fields,
            }
        );
    }
}
